"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceClozeTemplates = exports.ReplacementPolicy = void 0;
var ClozeRegex_1 = require("../../constants/ClozeRegex");
var clozeRegexForNum_1 = require("./clozeRegexForNum");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var ReplacementPolicy;
(function (ReplacementPolicy) {
    ReplacementPolicy[ReplacementPolicy["ColoredText"] = 0] = "ColoredText";
    ReplacementPolicy[ReplacementPolicy["Underscore"] = 1] = "Underscore";
})(ReplacementPolicy = exports.ReplacementPolicy || (exports.ReplacementPolicy = {}));
/**
 * Replaces cloze templates, e.g. {card1::Sacramento}, in the 'Text' field value.
 * Content for n cards is generated, where n = the number of distinct numbers that appear
 * in the cloze templates. n must be in the range [0, 10], otherwise the template will
 * not be replaced.
 *
 * @param fields The fields of the Cloze card. There should only be a single
 * field named 'Text'.
 */
function replaceClozeTemplates(fields, replacementPolicy) {
    if (replacementPolicy === void 0) { replacementPolicy = ReplacementPolicy.Underscore; }
    var textField = fields.find(function (field) { return field.name === "Text"; });
    (0, tiny_invariant_1.default)(textField != null, "Cloze card must have Text field");
    var textFieldValue = textField.value;
    // Only {cardi::...} where i is in the range [0, 9] is supported.
    var range = __spreadArray([], __read(Array(10).keys()), false);
    var replacements = range
        .map(function (i) {
        var regexForNum = (0, clozeRegexForNum_1.clozeRegexForNum)(i);
        if (textFieldValue.match(regexForNum)) {
            var front = textFieldValue
                // Replace cloze templates for current number with underlines.
                .replace(regexForNum, function (_match, p1) {
                switch (replacementPolicy) {
                    case ReplacementPolicy.ColoredText:
                        return "<span style=\"color:#5c61df\">".concat(p1, "</span>");
                    case ReplacementPolicy.Underscore:
                        return "_".repeat(p1.length);
                    default:
                        return "_".repeat(p1.length);
                }
            })
                // Replace the other cloze templates with the actual value.
                .replace(ClozeRegex_1.CLOZE_REGEX.CAPTURE_CONTENT, function (regexMatch, p1) {
                if (regexMatch.match(regexForNum)) {
                    return regexMatch;
                }
                return p1;
            });
            // The back of the card has no underlines, all cloze templates are replaced
            // with actual values.
            var back = textFieldValue.replace(ClozeRegex_1.CLOZE_REGEX.CAPTURE_CONTENT, "$1");
            return {
                back: "".concat(front, "\n\n<hr>\n\n").concat(back),
                front: front,
            };
        }
        return null;
    })
        .filter(function (obj) { return obj != null; });
    if (replacements.length === 0) {
        // We should disallow creating cloze cards with no cloze templates in the frontend.
        // But, to avoid confusion, just return the text unmodified for the front and back.
        return [
            {
                back: "".concat(textFieldValue, "\n\n<hr>\n\n").concat(textFieldValue),
                front: textFieldValue,
            },
        ];
    }
    return replacements;
}
exports.replaceClozeTemplates = replaceClozeTemplates;
